import { SELF_PICKUP as type } from '../actions/types';

const initialState = {
    validOrders: [],
    searchTnos: '',
    scannedOrders: [],
    signature: ''
}

export default function selfPickupReducer(state = initialState, action) {
    switch (action.type) {
        case type.HANDLE_VALID_TNOS:
            return {
                ...state,
                validOrders: action.payload,
            }
        case type.SAVE_SEARCH_TNOS:
            return {
                ...state,
                searchTnos: action.payload,
            }
        case type.HANDLE_SCANNED_TNOS:
            return {
                ...state,
                scannedOrders: action.payload,
            }
        case type.HANDLE_SIGNATURE:
            return {
                ...state,
                signature: action.payload,
            }
        default:
            return state;
    }
}